<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '300px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="黑白类型:" prop="listType">
              <a-radio-group v-model="searchList.listType">
                <a-radio :value="1">
                  黑名单
                </a-radio>
                <a-radio :value="2">
                  白名单
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="客户编号:" prop="custNo">
              <a-input v-model="searchList.custNo" :allowClear="true" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="客户名称:" prop="custName">
              <!-- <a-input v-model="searchList.custName" :allowClear="true" placeholder="请输入"/> -->
              <a-input v-model="searchList.custName" :allowClear="true" disabled>
                <a-icon type="ellipsis" slot="addonAfter" style="cursor: pointer;" @click="selectFn()"/>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="身份证号码:" prop="idCard">
              <a-input v-model="searchList.idCard" :allowClear="true" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="联系方式:" prop="phoneNo">
              <a-input v-model="searchList.phoneNo" :allowClear="true" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="录入时间:" prop="inputTime">
              <a-date-picker v-model="searchList.inputTime" :allowClear="true" style="width: 285px;" disabled/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>

    <!-- 表单 -->
    <selectModal
      v-if="selectVisible"
      :modalTitle="selectModalTitle"
      @close="close" 
      @handleOk="selectlHandleOk"
    ></selectModal>
  </div>
</template>

<script>
import moment from 'moment';
import selectModal from "./select-modal.vue";
export default {
  components: {
    selectModal
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "客户黑白名单",
    }, //标题
    data: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      visible: true,

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        listType: 1,
        custNo: "",
        custName: "",
        idCard: "",
        phoneNo:"",
        inputTime: moment(new Date()).format("YYYY-MM-DD"),
        id:"",
      },

      //校验规则
      rules: {
        listType: [
          {
            required: true,
            message: "黑白类型不能为空！",
            trigger: "blur",
          },
        ],
        custName: [
          {
            required: true,
            message: "客户名称不能为空！",
            trigger: "blur",
          },
        ],
      },

      //弹窗
      selectVisible: false,
      selectModalTitle: "",
    }
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleOk",this.searchList); 
        }
      });
    },

    //绑定客户
    selectFn() {
      this.selectVisible = true;
      this.selectModalTitle = "选择客户";
    },

    //关闭弹窗
    close() {
      this.selectVisible = false;
    },

    //弹窗确认
    selectlHandleOk(data) {
      this.searchList.custNo = data[0].custNo;
      this.searchList.custName = data[0].custName;
      this.searchList.idCard = data[0].idCard;
      this.searchList.phoneNo = data[0].phoneNo;
      this.searchList.id = data[0].id;

      this.selectVisible = false;
    },

  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
